// libraries
import $ from 'jquery';
import {debounce} from 'lodash';

// shared
import {ready} from 'shared/utils';
import 'stylesheets/login_signup.scss';

ready(() => {
  // Extracted from app/assets/javascripts/login_signup/login_signup.js
  var preventSubmit;
  var debounceSubmit = debounce(function() {
    preventSubmit = true;
  }, 1000, {'leading': true});

  $('.forgot-pw-form form').submit(function (e) {
    preventSubmit = false;
    debounceSubmit();

    if (preventSubmit !== true) {
      e.preventDefault();
    }
  });

  // Extracted from app/assets/javascripts/login_signup/email_mobile_mask.js
  var $emailMobileInput = $('#email-mobile-input');
  var $emailMobileType = $('#email-mobile-type');
  // Checks if the string is an email addres.
  var emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var alphaNumRegExp = /[()+\s.-]/g;
  var mobileRegExp = /^\d+$/;
  var mobileDelimetersRegExp = /[()-]/
  var wasMobile = false;

  $emailMobileInput.on('input', function(e) {
    var emailPhoneVal = $emailMobileInput.val();
    var alphaNum = emailPhoneVal.replace(alphaNumRegExp, '');
    var isMobile = mobileRegExp.test(emailPhoneVal);
    var couldBeMobile = mobileRegExp.test(emailPhoneVal.replace(alphaNumRegExp, ''));
    var isEmail = emailRegExp.test(emailPhoneVal);
    var isNowMobile = couldBeMobile && !wasMobile;

    if (wasMobile && mobileDelimetersRegExp.test(emailPhoneVal.slice(-1))) {
      wasMobile = false;
      $emailMobileType.val('email');
    } else if (isMobile || couldBeMobile && wasMobile || isNowMobile) {
      var x = emailPhoneVal.replace(/\D/g, '')
                           .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      var numStr = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      $emailMobileInput.val(numStr);
      wasMobile = true;
      $emailMobileType.val('mobile');
    } else if (wasMobile) {
      $emailMobileInput.val(emailPhoneVal.replace(/[()-\s]/g, ''));
      wasMobile = false;
      $emailMobileType.val('email');
    }
  });
});
